import { rootRoute } from './rootRoute';
import { loginRoute } from './loginRoute';
import { verifyOtpRoute } from './verifyOtpRoute';
import { forgotPasswordRoute } from './forgotPasswordRoute';
import { resetPasswordRoute } from './resetPasswordRoute';
import { dashboardRoute } from './dashboardRoute';
import { notFoundRoute } from './notFoundRoute';
import { dispatchDetailsRoute } from './dispatchDetailsRoute';

// Remove balanceRoute from here since it's now a child of dashboardRoute
export const routes = [
  rootRoute,
  loginRoute,
  verifyOtpRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  dashboardRoute,
  notFoundRoute,
  dispatchDetailsRoute,
];
